<template>
  <div
    class="text-input"
    :class="{ 'text-input--center': centerPlaceholder, 'text-input--big': big }"
  >
    <label class="text-input__label-wrapper">
      <span class="text-input__label">{{ placeholder }}</span>
      <textarea
        :value="value"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :type="type"
        :maxLength="maxLength"
        class="text-input__input text-input__input--textarea"
        @input="handleInput"
        @focus="$emit('focus')"
      />
    </label>

    <button
      v-if="button"
      ref="button"
      class="text-input__button"
      :class="{ 'text-input__button--xs-hide': xsHideButton }"
      @click.prevent="$emit('click')"
    >
      {{ button }}
    </button>
    <span
      v-if="hint"
      class="text-input__hint"
      :class="{ 'text-input__hint--alert': hintAlert }"
    >
      {{ hint }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    button: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    centerPlaceholder: {
      type: Boolean,
      default: false
    },
    big: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    },
    xsHideButton: {
      type: Boolean,
      default: false
    },
    hintAlert: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 1000
    }
  },
  methods: {
    handleInput ({ target = {} } = {}) {
      this.$emit('input', target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .text-input {
    width: 100%;
    position: relative;
    display: flex;
    border-bottom: $accent-opposite-color 3px solid;

    &__input {
      @include reset-input;
      @include reset-placeholder;
      @include font($akrobat-font, 900);
      outline: 0;

      padding-right: 8px;
      width: 100%;
      position: relative;
      resize: vertical;
      height: 170px;

      @media screen and (max-height: 480px) {
        height: 110px;
      }

      &:invalid {
        border: 0;
        outline: 0;
        box-shadow: none;
      }

      &:disabled {
        color: $accent-opposite-color;
        opacity: 1;
      }
    }

    &--center &__input::placeholder {
      text-align: center;
    }

    &__input,
    &__button,
    &__hint {
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: .05em;
      line-height: 2;
      color: $accent-opposite-color;
    }

    &__hint {
      transition: color $base-transition;

      &--alert {
        color: black;
      }
    }

    &--big {
      @include media-up(xl) {
        border-bottom-width: 5px;
      }
    }

    &--big &__input {
      letter-spacing: .4em;
      line-height: 2.25;

      @include media-up(xl) {
        font-size: 18px;
      }
    }

    &--big &__button {
      line-height: 2.25;
    }

    &__button {
      @include reset-button;
      @include font($akrobat-font, 300);

      transition: opacity $base-transition;

      &:hover {
        opacity: .8;
      }

      &--xs-hide {
        @include hide-down(md);
      }
    }

    &__label-wrapper {
      flex-grow: 1;
    }

    &__label {
      @include visually-hidden;
    }

    &__hint {
      @include font($akrobat-font, 300);

      position: absolute;
      right: 0;
      bottom: -3px;
      transform: translateY(100%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TextareaInput.vue